import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2, Activity } from "lucide-react";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit", { params: { limit: 200 } })
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="surface p-5 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="heading-section">Audit Log</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Every consequential action across the platform.</p>
        </div>
      </div>
      {loading ? (
        <div className="text-sm text-muted-foreground py-6 text-center"><Loader2 className="w-4 h-4 inline animate-spin" /> Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-sm text-muted-foreground py-6 text-center"><Activity className="w-8 h-8 mx-auto mb-2 opacity-40" /> No activity yet.</div>
      ) : (
        <div className="overflow-x-auto scrollbar-thin">
          <table className="w-full text-sm">
            <thead className="border-b border-border bg-secondary/40">
              <tr className="text-left">
                <th className="px-3 py-2 font-semibold">When</th>
                <th className="px-3 py-2 font-semibold">User</th>
                <th className="px-3 py-2 font-semibold">Action</th>
                <th className="px-3 py-2 font-semibold">Resource</th>
                <th className="px-3 py-2 font-semibold">IP</th>
              </tr>
            </thead>
            <tbody>
              {items.map((l) => (
                <tr key={l.id} className="border-b border-border last:border-0 hover:bg-secondary/30" data-testid={`audit-log-${l.id}`}>
                  <td className="px-3 py-2.5 text-xs text-muted-foreground tabular-nums">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-3 py-2.5">{l.user_email || "—"}</td>
                  <td className="px-3 py-2.5 font-mono text-xs">{l.action}</td>
                  <td className="px-3 py-2.5 text-xs text-muted-foreground">
                    {l.resource_type ? `${l.resource_type}${l.resource_id ? `: ${l.resource_id.slice(0, 8)}…` : ""}` : "—"}
                  </td>
                  <td className="px-3 py-2.5 text-xs text-muted-foreground">{l.ip_address || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
